/**
 * 本文中の全出現位置を返す。重なりのない前方一致で走査する。
 * @graph-connects none
 */
function occurrencesOf(text, surface, isSynonym) {
    if (surface.length === 0)
        return [];
    const found = [];
    let cursor = text.indexOf(surface);
    while (cursor >= 0) {
        found.push({ surface, start: cursor, end: cursor + surface.length, isSynonym });
        cursor = text.indexOf(surface, cursor + surface.length);
    }
    return found;
}
/**
 * 本文 1 つ × Term 1 件分の出現を位置順に集める。判定は `extractTermEdges` と同じ
 * 「表記の完全一致が本文に含まれるか」である。
 *
 * `getTermDetail` の逆引き行（どの表記で何回当たったか）も同じ経路を通す。走査を
 * 2 箇所に書くと、用語解決が拾う出現と逆引きが数える出現が食い違いうる。
 *
 * **BQ に触れないこの module に置くのは、同じ判定をブラウザでも走らせるためである。**
 * 用語の自動リンクは画面側が辞書（表記索引）を受け取って本文ごとに解決する。判定を
 * 画面側へ書き写すと、抽出（USES_TERM エッジ）とリンクが別の規則で動き、「エッジには
 * 載るのにリンクは付かない」語が静かに生まれる。
 *
 * @graph-stack spec-graph
 * @graph-domain Engineering
 * @graph-business 本文 1 つに対する Term 1 件の全出現を位置順に返す（用語解決と逆引きと自動リンクの共通経路）
 * @graph-connects none
 */
export function termOccurrencesIn(text, surfaces) {
    const synonyms = new Set(surfaces.synonyms);
    return surfaces.all
        .flatMap((surface) => occurrencesOf(text, surface, synonyms.has(surface)))
        .sort((left, right) => left.start - right.start);
}
//# sourceMappingURL=terms.js.map